import { RankedTester, rankWith, uiTypeIs } from "@jsonforms/core";
import React from "react";

export const gNavFooterRendererTester: RankedTester = rankWith(
  4,
  uiTypeIs("GNavFooter")
);

function GNavFooterRenderer() {
  return <div data-testid="feds-footer" id="feds-footer" />;
}

export default GNavFooterRenderer;
